module.exports = __webpack_public_path__ + "img/86c296e75b5bc1c9e190d49ac632bd25.png";